/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Found a data error or have a feature suggestion? Toolverse is an independent project. Reach out at ${i?.email}. Toolverse is not affiliated with Formula 1, the FIA, the official F1 Fantasy game, or any other brand its tools reference.`)
};

const es_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Encontraste un error en los datos o tienes una sugerencia de función? Toolverse es un proyecto independiente. Escríbenos a ${i?.email}. Toolverse no está afiliado a Fórmula 1, la FIA, el juego oficial F1 Fantasy, ni a ninguna otra marca que sus herramientas mencionen.`)
};

const de_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einen Datenfehler gefunden oder einen Funktionswunsch? Toolverse ist ein unabhängiges Projekt. Schreib uns an ${i?.email}. Toolverse ist nicht mit Formel 1, der FIA, dem offiziellen F1-Fantasy-Spiel oder einer anderen Marke, auf die seine Werkzeuge verweisen, verbunden.`)
};

const nl_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Een datafout gevonden of een functiesuggestie? Toolverse is een onafhankelijk project. Neem contact op via ${i?.email}. Toolverse is niet verbonden aan Formule 1, de FIA, het officiële F1 Fantasy-spel of enig ander merk waarnaar de tools verwijzen.`)
};

const fr_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez trouvé une erreur de données ou avez une suggestion de fonctionnalité ? Toolverse est un projet indépendant. Contactez-nous à ${i?.email}. Toolverse n’est affilié ni à la Formule 1, ni à la FIA, ni au jeu F1 Fantasy officiel, ni à aucune autre marque mentionnée par ses outils.`)
};

const it_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai trovato un errore nei dati o hai un suggerimento per una funzionalità? Toolverse è un progetto indipendente. Scrivici a ${i?.email}. Toolverse non è affiliato alla Formula 1, alla FIA, al gioco ufficiale F1 Fantasy né a qualsiasi altro marchio citato dai suoi strumenti.`)
};

const pt_br2_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encontrou um erro nos dados ou tem uma sugestão de recurso? A Toolverse é um projeto independente. Entre em contato em ${i?.email}. A Toolverse não é afiliada à Fórmula 1, à FIA, ao jogo oficial F1 Fantasy ou a qualquer outra marca mencionada por suas ferramentas.`)
};

const pt_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Encontrou um erro nos dados ou tem uma sugestão de funcionalidade? A Toolverse é um projeto independente. Contacte-nos através de ${i?.email}. A Toolverse não está afiliada à Fórmula 1, à FIA, ao jogo oficial F1 Fantasy ou a qualquer outra marca mencionada pelas suas ferramentas.`)
};

const ja_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`データの誤りを発見した場合や機能提案がありますか？Toolverseは独立したプロジェクトです。${i?.email}までご連絡ください。Toolverseは、Formula 1、FIA、公式F1ファンタジーゲーム、またはツールが言及するその他のブランドとは提携していません。`)
};

const zh_about_contact_text = /** @type {(inputs: { email: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`发现数据错误或有功能建议？Toolverse 是一个独立项目。请通过 ${i?.email} 联系我们。Toolverse 与 F1、FIA、官方 F1 Fantasy 游戏或其工具提及的任何其他品牌均无关联。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ email: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_contact_text = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_contact_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_contact_text", locale)
	if (locale === "en") return en_about_contact_text(inputs)
	if (locale === "es") return es_about_contact_text(inputs)
	if (locale === "de") return de_about_contact_text(inputs)
	if (locale === "nl") return nl_about_contact_text(inputs)
	if (locale === "fr") return fr_about_contact_text(inputs)
	if (locale === "it") return it_about_contact_text(inputs)
	if (locale === "pt-BR") return pt_br2_about_contact_text(inputs)
	if (locale === "pt") return pt_about_contact_text(inputs)
	if (locale === "ja") return ja_about_contact_text(inputs)
	return zh_about_contact_text(inputs)
};